import {
  IDispatcher,
  IMotorCarrierDetail,
  ITeamMember,
  TEAM_MEMBER_USER_TYPES,
} from 'apps/fleet-planner/types'

const nondriverUserTypes: (TEAM_MEMBER_USER_TYPES | undefined)[] = [
  TEAM_MEMBER_USER_TYPES.DISPATCHER,
  TEAM_MEMBER_USER_TYPES.OWNER_OPERATOR,
]

export const hasNondriverUserType = (
  carrierDetails?: Pick<IMotorCarrierDetail, 'userType'>[]
): boolean => {
  if (!carrierDetails) return false

  return carrierDetails.some(mcd => {
    const { userType } = mcd || {}
    return nondriverUserTypes.includes(userType)
  })
}

export const hasDrivers = (carrierDetails?: Pick<IMotorCarrierDetail, 'userType'>[]): boolean => {
  return (carrierDetails || []).some(mcd => {
    const { userType } = mcd || {}
    return (
      userType === TEAM_MEMBER_USER_TYPES.DRIVER ||
      userType === TEAM_MEMBER_USER_TYPES.OWNER_OPERATOR
    )
  })
}

export const hasDispatchers = (
  carrierDetails?: Pick<IMotorCarrierDetail, 'userType'>[]
): boolean => {
  return (carrierDetails || []).some(mcd => {
    const { userType } = mcd || {}
    return (
      userType === TEAM_MEMBER_USER_TYPES.DISPATCHER ||
      userType === TEAM_MEMBER_USER_TYPES.OWNER_OPERATOR
    )
  })
}

export const teamMembertoDispatcher = (
  teamMember?: Pick<ITeamMember, 'id' | 'firstName' | 'lastName'>
): Pick<IDispatcher, 'id' | 'fullName'> | undefined => {
  if (!teamMember) return undefined
  const { firstName = '', id, lastName = '' } = teamMember || {}
  return {
    id: id ? String(id) : '',
    fullName: `${firstName} ${lastName}`.trim(),
  }
}
